import type { Client, RequestContext } from "../client";

export interface AdoraUserPropertiesResource {
    UserId: string;
    InstallationId: string;
    IsTrial: boolean;
    LicenseId: string;
    HostEnvironment: string;
    LicenseSerialNumberHash?: string;
}

export class AdoraRepository {
    constructor(
        private readonly client: Client,
        private readonly requestContext: RequestContext
    ) {
        this.client = client;
    }

    getUserProperties(): Promise<AdoraUserPropertiesResource> {
        return this.client.get<AdoraUserPropertiesResource>(this.requestContext, "~/bff/adora/userproperties");
    }
}
